import React from 'react';
import 'react-dom';
import { Component } from '@gondel/core';
import { GondelReactComponent } from '@gondel/plugin-react';
import { IMainNavigationModel } from '@swisslife/shared-types/src/aem/models/MainNavigationModel';

@Component('NavigationListRenderer')
export class NavigationListRenderer extends GondelReactComponent<IMainNavigationModel> {
	private NavigationList: any;

	public async start() {
		// tslint:disable-next-line
		this.NavigationList = ((await import(/* webpackChunkName: "dynamic-imports/main-navigation" */ './NavigationList')) as any).NavigationList;
	}

	/**
	 * This component is the bridge between gondel and react
	 * and does nothing less than rendering the navigation list
	 * via react.
	 */
	public render() {
		const NavigationList = this.NavigationList;
		return <NavigationList {...this.state} />;
	}
}
